import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { auth, markStaffSession } from "../services/api";
import { idleMs, setOnActive, resetActivity, IDLE_LIMIT_MS, IDLE_WARN_MS } from "../services/activity"; // v3.4.509
import toast from "react-hot-toast";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mfa, setMfa] = useState(null); // v3.4.510 — الخطوة الثانية معلّقة بعد دخول Google (بيانات شاشة الرمز)

  const refreshUser = useCallback(async () => {
    try {
      const res = await auth.getUser();
      setUser(res.data.user);
      setMfa(res.data.mfa_pending ? (res.data.mfa || {}) : null);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    auth
      .getUser()
      .then((res) => { setUser(res.data.user); setMfa(res.data.mfa_pending ? (res.data.mfa || {}) : null); })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    await auth.logout();
    setUser(null);
    window.location.href = "/login";
  };

  // v3.4.509 — سياسة الجلسات: خروج تلقائي بعد 30 دقيقة بلا نشاط (تنبيه قبلها بدقيقتين) + نبضة كل 4 دقائق أثناء النشاط
  useEffect(() => {
    markStaffSession(!!user);
    if (!user) { setOnActive(null); return undefined; }
    resetActivity();
    let lastPing = Date.now(), warned = false;
    setOnActive((now) => {
      warned = false;
      if (now - lastPing > 4 * 60 * 1000) { lastPing = now; auth.getUser().catch(() => {}); } // يحدّث «آخر نشاط» على الخادم حتى بلا طلبات أخرى
    });
    const t = setInterval(() => {
      const idle = idleMs();
      if (idle >= IDLE_LIMIT_MS) {
        clearInterval(t);
        auth.logout().catch(() => {}).then(() => { window.location.replace("/login?error=idle_timeout"); });
      } else if (idle >= IDLE_WARN_MS && !warned) {
        warned = true;
        toast("⏳ ستنتهي الجلسة بعد دقيقتين لعدم النشاط — حرّك الفأرة أو اضغط أي مفتاح للاستمرار", { duration: 20000 });
      }
    }, 15000);
    return () => { clearInterval(t); setOnActive(null); };
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading, logout, refreshUser, mfa }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
